import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import DragDrop from '../DragDrop';
export default (function (_ref) {
  var children = _ref.children,
      onDragStart = _ref.onDragStart,
      onDragUpdate = _ref.onDragUpdate,
      _onDragEnd = _ref.onDragEnd,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "onDragStart", "onDragUpdate", "onDragEnd"]);

  return /*#__PURE__*/React.createElement(DragDrop.Provider, {
    onDragStart: onDragStart,
    onDragUpdate: onDragUpdate,
    onDragEnd: function onDragEnd(props) {
      return props.destination && _onDragEnd(props);
    }
  }, /*#__PURE__*/React.createElement(Box, restProps, children));
});